import { loginService } from '@vip-activity/business/userState';
import JsCookie from 'js-cookie';
import { ICookie } from './index.interface';

export class Cookie implements ICookie {
  private cookies = JsCookie.get()

  constructor() {
    loginService.onLoginStateChange(() => {
      this.cookies = JsCookie.get();
    });
  }

  get(name: string): string {
    return this.cookies[name];
  }

  set(name: string, value: string): void {
    JsCookie.set(name, value);
    this.cookies = JsCookie.get();
  }

  remove(name: string): void {
    JsCookie.remove(name);
    this.cookies = JsCookie.get();
  }
}

const cookie = new Cookie();
export default cookie;
